import { render, staticRenderFns } from "./WorkPlace.vue?vue&type=template&id=a110c7cc"
import script from "./WorkPlace.vue?vue&type=script&lang=js"
export * from "./WorkPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports